export default "__VITE_ASSET__T_PtR955__"